import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGO, LogoWord } from "./Brand";

export default function Footer() {
  return (
    <footer className="relative bg-background overflow-hidden" data-testid="site-footer">
      {/* faded letterhead watermark */}
      <img src={LOGO} alt="" className="watermark w-[60vw] max-w-[720px] right-[-6%] bottom-[-10%]" />

      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 relative">
        <div className="gold-rule gold-rule-node" />

        <div className="py-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <LogoWord />
            <p className="mt-7 text-sm text-steel-text leading-relaxed max-w-md">
              An engineering and technology company building practical industrial
              products, automation and electrical systems, smart electronics and
              digital platforms — with research into industrial intelligence for
              the decades ahead.
            </p>
            <div className="mt-6 font-mono-2 text-[10px] tracking-[0.28em] uppercase text-muted-foreground">
              Founded by Abhilash Bhattacharya · Ahmedabad
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <div className="font-mono-2 text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-5">Navigate</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="aurora-underline">Home</Link></li>
              <li><Link to="/services" className="aurora-underline">Services</Link></li>
              <li><Link to="/products" className="aurora-underline">Products</Link></li>
              <li><Link to="/genesys" className="aurora-underline">GENESYS</Link></li>
              <li><Link to="/shop" className="aurora-underline" data-testid="footer-shop-link">Shop</Link></li>
              <li><Link to="/#epc" className="aurora-underline">EPC Partner</Link></li>
              <li><Link to="/#why" className="aurora-underline">Why Us</Link></li>
              <li><Link to="/#research" className="aurora-underline">Research</Link></li>
              <li><Link to="/#contact" className="aurora-underline">Contact</Link></li>
              <li><Link to="/login" className="aurora-underline">Client Portal</Link></li>
              <li><Link to="/intro" className="aurora-underline" data-testid="footer-intro-link">Brand Intro</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-2 text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-5">Contact</div>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="leading-relaxed">B-435, Supath II Commercial Complex,<br/>Ashram Road, Usmanpura,<br/>Ahmedabad 380013</li>
              <li><a href="tel:+919924792096" className="aurora-underline text-foreground">+91 99247 92096</a></li>
              <li><a href="mailto:contact@debsuntechnologies.com" className="aurora-underline text-foreground" data-testid="footer-contact-email">contact@debsuntechnologies.com</a></li>
              <li><a href="mailto:hello@debsuntechnologies.in" className="aurora-underline text-foreground" data-testid="footer-hello-email">hello@debsuntechnologies.in</a></li>
              <li><a href="https://linkedin.com/in/abhilashdebsun" target="_blank" rel="noreferrer" className="aurora-underline text-foreground">linkedin.com/in/abhilashdebsun</a></li>
            </ul>
          </div>
        </div>

        <div className="gold-rule" />

        <div className="py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono-2 text-[10px] tracking-[0.22em] uppercase text-muted-foreground">
          <span data-testid="footer-legal-line">
            © 2026 DEBSUN Technologies · GST: 24CSMPB5149K1ZK · MSME (UDYAM) · Grievance: <a href="mailto:admin@debsuntechnologies.com" className="text-foreground aurora-underline">admin@debsuntechnologies.com</a>
          </span>
          <span className="text-[color:var(--gold)]">— Intelligence in Motion —</span>
        </div>
      </div>
    </footer>
  );
}
